import { render, staticRenderFns } from "./GymSectorCard.vue?vue&type=template&id=7bc94db4"
import script from "./GymSectorCard.vue?vue&type=script&lang=js"
export * from "./GymSectorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports